import React, { memo } from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import { MimeTypeIcon } from "fond/widgets";

import { MimeTypeIconWrapper } from "./styles";

const MimeTypeCellRenderer: React.FC<ICellRendererParams> = memo((params: ICellRendererParams) => {
  if (!params.value) {
    return null;
  }
  return (
    <MimeTypeIconWrapper>
      <MimeTypeIcon mimeType={params.value} />
    </MimeTypeIconWrapper>
  );
});

MimeTypeCellRenderer.displayName = "MimeTypeCellRenderer";

export default MimeTypeCellRenderer;
